export const PERMIT_DEFAULTS = {
  DEFAULT_PERMIT_DURATION: 7,
};
